import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

/**
 * 301 Redirect page for /study-stream/ -> /studystream/
 * This page includes proper SEO signals for search engines:
 * - Canonical URL pointing to /studystream/
 * - Meta refresh redirect
 * - noindex to prevent indexing
 * - JavaScript redirect for browsers
 */
const StudyStreamRedirect = () => {
  useEffect(() => {
    // Client-side redirect
    window.location.replace("/studystream/");
  }, []);

  return (
    <>
      <Helmet>
        <title>Redirecting to Study Stream | CSW</title>
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://csw.live/studystream/" />
        <meta httpEquiv="refresh" content="0;url=/studystream/" />
        {/* Add HTTP status hint for crawlers */}
        <meta name="prerender-status-code" content="301" />
      </Helmet>
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <p className="text-muted-foreground">Redirecting to Study Stream...</p>
          <a href="/studystream/" className="text-primary hover:underline mt-2 block">
            Click here if not redirected
          </a>
        </div>
      </div>
    </>
  );
};

export default StudyStreamRedirect;
